var Actions;
(function (Actions) {
    Actions["GET_ASSET_PROFILLING_LIST"] = "getAssetProfillingList";
    Actions["GET_ASSET_PROFILLING_LIST_CODE_DESC"] = "getAssetProfillingListCodeDesc";
    Actions["CREATE_ASSET_PROFILLING_LIST"] = "createAssetProfillingList";
    Actions["UPDATE_ASSET_PROFILLING_LIST"] = "updateAssetProfillingList";
    Actions["GET_ASSET_PROFILLING_LIST_FILTER"] = "getAssetProfillingListFilter";
    Actions["GET_ASSET_PROFILLING_DATA"] = "getAssetProfillingData";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_CODE"] = "updateSelectedAssetProfillingCode";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_DESC"] = "updateSelectedAssetProfillingDesc";
    Actions["UPDATE_SELECTED_ASSET_PROFILLING_ACTIVE"] = "updateSelectedAssetProfillingActive";
    Actions["UPDATE_ASSET_PROFILLING_SIZE"] = "updateAssetProfillingSize";
    Actions["RESET_ASSET_PROFILLING_FILTER"] = "resetAssetProfillingFilter";
    Actions["DOWNLOAD_ASSET_PROFILLING"] = "downloadAssetProfilling";
    Actions["UPDATE_ASSET_PROFILLING_PAGE_FILTER"] = "updateAssetProfillingPageFilter";
    Actions["UPDATE_SEARCH_ASSET_PROFILLING_DESC"] = "updateSearchAssetProfillingDesc";
    Actions["UPDATE_SEARCH_ASSET_PROFILLING_CODE"] = "updateSearchAssetProfillingCode";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_ASSET_PROFILLING_WAS_FIRST_LOAD"] = "setAssetProfillingWasFirstLoad";
    Mutations["SET_ASSET_PROFILLING_LOADING"] = "setAssetProfillingLoading";
    Mutations["SET_ASSET_PROFILLING_HANDLE_PAGE"] = "setAssetProfillingHandlePage";
    Mutations["SET_ASSET_PROFILLING_LIST"] = "setAssetProfillingList";
    Mutations["SET_ASSET_PROFILLING_LIST_CODE"] = "setAssetProfillingListCode";
    Mutations["SET_ASSET_PROFILLING_LIST_DESC"] = "setAssetProfillingListDesc";
    Mutations["SET_ASSET_PROFILLING_PAGE"] = "setAssetProfillingPage";
    Mutations["SET_ASSET_PROFILLING_LOAD_PAGE"] = "setAssetProfillingLoadPage";
    Mutations["SET_SELECTED_ASSET_PROFILLING_CODE"] = "setSelectedAssetProfillingCode";
    Mutations["SET_SELECTED_ASSET_PROFILLING_DESC"] = "setSelectedAssetProfillingDesc";
    Mutations["SET_SELECTED_ASSET_PROFILLING_ACTIVE"] = "setSelectedAssetProfillingActive";
    Mutations["SET_ASSET_PROFILLING_STATUS"] = "setAssetProfillingStatus";
    Mutations["SET_ASSET_PROFILLING_SIZE"] = "setAssetProfillingSize";
    Mutations["SET_ASSET_PROFILLING_USE_FILTER"] = "setAssetProfillingUseFilter";
    Mutations["SET_ASSET_PROFILLING_PAGE_FILTER"] = "setAssetProfillingPageFilter";
    Mutations["SET_ASSET_PROFILLING_WAS_LOAD_QUICK_FILTER"] = "setAssetProfillingWasLoadQuickFilter";
    Mutations["SET_ASSET_PROFILLING_SEARCH_BY"] = "setAssetProfillingSearchBy";
    Mutations["SET_ASSET_PROFILLING_SEARCH_KEY"] = "setAssetProfillingSearchKey";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
